import { DollarSign, Users, Target, Calendar } from "lucide-react";

interface AdminStatsProps {
  totalRevenue: number;
  totalUsers: number;
  totalBids: number;
  eventsCount: number;
}

const AdminStats = ({
  totalRevenue,
  totalUsers,
  totalBids,
  eventsCount,
}: AdminStatsProps) => {
  return (
    <>
      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="glass-card p-6 flex items-center gap-4">
          <div className="p-3 rounded-xl bg-primary/10">
            <DollarSign size={24} className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Revenue</p>
            <p className="text-2xl font-bold text-primary">
              {totalRevenue.toLocaleString()} DC
            </p>
          </div>
        </div>
        <div className="glass-card p-6 flex items-center gap-4">
          <div className="p-3 rounded-xl bg-cyan-500/10">
            <Users size={24} className="text-cyan-500" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Users</p>
            <p className="text-2xl font-bold text-cyan-500">{totalUsers}</p>
          </div>
        </div>
        <div className="glass-card p-6 flex items-center gap-4">
          <div className="p-3 rounded-xl bg-success/10">
            <Target size={24} className="text-success" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Predictions</p>
            <p className="text-2xl font-bold text-success">{totalBids}</p>
          </div>
        </div>
        <div className="glass-card p-6 flex items-center gap-4">
          <div className="p-3 rounded-xl bg-accent/10">
            <Calendar size={24} className="text-accent" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Events</p>
            <p className="text-2xl font-bold text-accent">{eventsCount}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminStats;
